import Vue from 'vue';

import {
  roundToTwo,
} from '@/utils/helper';

Vue.filter('commaFormat', (val) => `${roundToTwo(val)}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));

Vue.filter('priceFormat', (val) => `$${val}`);
